import {
    INSERT_REPORT_ITEM,
    WEBCAM_NEXT_STEP,
    INTRO_NEXT_STEP,
    MICROPHONE_NEXT_STEP,
    SPEAKER_NEXT_STEP,
    WEBRTC_NEXT_STEP,
    GO_TO_MICROPHONE,
    GO_TO_SPEAKER,
    GO_TO_WEBRTC,
    GO_TO_REPORT,
    WEBCAM_RESET,
    MICRO_RESET,
    UPDATE_TECHNICAL_CONFIG,
    SPEAKER_RESET,
    RUN_CONFORMITY,
    RESET_CONFORMITY,
    GO_TO_WEBCAM,
    WEBRTC_P2P_OK,
} from './types'

export const insertReportItem = (pLabel: any, pValue: any, pStatus: any) => (dispatch: any) => {
    dispatch({
        type: INSERT_REPORT_ITEM,
        payload: {
            label: pLabel,
            value: pValue,
            status: pStatus,
        },
    })
}

export const nextIntroStep = () => (dispatch: any) => {
    dispatch({
        type: INTRO_NEXT_STEP,
    })
}

export const nextWebcamStep = () => (dispatch: any) => {
    dispatch({
        type: WEBCAM_NEXT_STEP,
    })
}

export const resetWebcamTest = () => (dispatch: any) => {
    dispatch({
        type: WEBCAM_RESET,
    })
}

export const resetMicroTest = () => (dispatch: any) => {
    dispatch({
        type: MICRO_RESET,
    })
}

export const resetSpeakerTest = () => (dispatch: any) => {
    dispatch({
        type: SPEAKER_RESET,
    })
}

export const nextMicrophoneStep = () => (dispatch: any) => {
    dispatch({
        type: MICROPHONE_NEXT_STEP,
    })
}

export const nextSpeakerStep = () => (dispatch: any) => {
    dispatch({
        type: SPEAKER_NEXT_STEP,
    })
}

export const nextWebrtcStep = () => (dispatch: any) => {
    dispatch({
        type: WEBRTC_NEXT_STEP,
    })
}

export const goToDownloadSpeed = () => (dispatch: any) => {
    dispatch({
        type: WEBRTC_P2P_OK,
    })
}

export const goToWebcam = () => (dispatch: any) => {
    setTimeout(() => {
        dispatch({
            type: GO_TO_WEBCAM,
        })
    }, 1000)
}

export const goToMicrophone = () => (dispatch: any) => {
    setTimeout(() => {
        dispatch({
            type: GO_TO_MICROPHONE,
        })
    }, 1000)
}

export const goToSpeaker = () => (dispatch: any) => {
    setTimeout(() => {
        dispatch({
            type: GO_TO_SPEAKER,
        })
    }, 1000)
}

export const goToWebrtc = () => (dispatch: any) => {
    setTimeout(() => {
        dispatch({
            type: GO_TO_WEBRTC,
        })
    }, 1000)
}

export const goToReport = () => (dispatch: any) => {
    setTimeout(() => {
        dispatch({
            type: GO_TO_REPORT,
        })
    }, 1000)
}

export const updateTechnicalConfig = (value: any) => (dispatch: any) => {
    dispatch({
        type: UPDATE_TECHNICAL_CONFIG,
        payload: {
            value,
        },
    })
}

export const runConformity = (value: any) => (dispatch: any) => {
    dispatch({
        type: RUN_CONFORMITY,
        payload: {
            open: value,
        },
    })
    if (!value) {
        dispatch({
            type: RESET_CONFORMITY,
        })
    }
}
